import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FileCopyIcon from "@mui/icons-material/FileCopy";

export interface IProps {
  /**
   * ボタンが押された場合に呼び出されます
   */
  onClick?: () => void;
}

export default function CopyButton(props: IProps) {
  const [open, setOpen] = useState(false);
  function handleMouseOver() {
    if (open === false) {
      setOpen(true);
    }
  }
  function handleMouseLeave() {
    if (open === true) {
      setOpen(false);
    }
  }
  return (
    <Tooltip title="copy" arrow placement="bottom" open={open}>
      <IconButton
        aria-label="copy"
        onClick={props.onClick}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
      >
        <FileCopyIcon />
      </IconButton>
    </Tooltip>
  );
}
